import { Typography, styled } from '@mui/material';

export const CircleText = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  lineHeight: '2rem',
  color: theme.palette.primary.main,
}));
